import { render, staticRenderFns } from "./IssuePassButton.vue?vue&type=template&id=2220b0dc&"
import script from "./IssuePassButton.vue?vue&type=script&lang=js&"
export * from "./IssuePassButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports